export default __webpack_public_path__ + "static/media/omuk2.7e97901f.webp";